import React from 'react';
import { Box, Flex, Subhead, Small } from 'rebass';
import { withProps } from 'recompose';
import { site, contact } from '../app/data';
import FacebookPageLink from '../app/components/facebook_page_link';
import FacebookLikeButton from '../app/components/facebook_like_button';
import GithubButton from '../app/components/github_button';
import Link from '../app/components/link';
import Email from '../app/components/email';

const Rows = withProps({
  column: true,
  flex: '1 1 auto',
})(Flex);

export default () => (
  <Box bg="greyLight">
    <Flex
      pt={4}
      pb={3}
      mx={[3, 5]}
      px={[2, 0]}
    >
      <Box>
        <Subhead>Dynopia</Subhead>
        <Rows mt={3}>
          <Small>
            <Email address={contact.email} />
          </Small>
          <Box mt={2}>
            <FacebookPageLink url={contact.facebookPage.url} />
          </Box>
        </Rows>
      </Box>
      <Rows align="flex-end" justify="flex-end">
        <Box>
          <FacebookLikeButton
            appId={site.meta.facebook.appId}
            url={contact.facebookPage.url}
          />
        </Box>
        <Box mt={2} mb={-2}>
          <GithubButton />
        </Box>
      </Rows>
    </Flex>
    <Box
      pb={4}
      mx={[3, 5]}
      px={[2, 0]}
    >
      <Link to="/tos/">
        <Small>Terms of Service</Small>
      </Link>
    </Box>
  </Box>
);



// WEBPACK FOOTER //
// ./src/Footer/index.js